export const overwriteMerger = (_: any, newVal: any) => newVal;
